import React from 'react';
import axios from 'axios';
import { Button, Form, Header, Segment } from 'semantic-ui-react';
import {toast, ToastContainer} from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class NewSP2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            description: this.props.description,
            enrollmentTerms: this.props.enrollmentTerms,
            studyRules: this.props.studyRules,
            descriptionEng: this.props.descriptionEng,
            enrollmentTermsEng: this.props.enrollmentTermsEng,
            studyRulesEng: this.props.studyRulesEng,

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.step3 = this.step3.bind(this);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    step3() {
        this.props.step3(
            this.state.description,
            this.state.enrollmentTerms,
            this.state.studyRules,
            this.state.descriptionEng,
            this.state.enrollmentTermsEng,
            this.state.studyRulesEng,
        );
    }

    previousStep() {
        const step = 1;
        this.props.previousStep(step);
    }


    render() {
        return (
            <div>
                <Header as="h1">Kreiranje implementacije smjera (studijskog programa)</Header>

                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Ostali podaci o smjeru (studijskom programu)
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Opis</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.description}
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>&nbsp;</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.descriptionEng}
                                        onChange={(e) => this.setState({ descriptionEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Uslovi upisa</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.enrollmentTerms}
                                        onChange={(e) => this.setState({ enrollmentTerms: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>&nbsp;</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.enrollmentTermEng}
                                        onChange={(e) => this.setState({ enrollmentTermsEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Pravila studiranja</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.studyRules}
                                        onChange={(e) => this.setState({ studyRules: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>&nbsp;</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.studyRulesEng}
                                        onChange={(e) => this.setState({ studyRulesEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment clearing>
                        <Button
                            color="blue"
                            basic="true"
                            onClick={this.previousStep}
                        >Nazad</Button>
                        <Button
                            color="blue"
                            floated="right"
                            onClick={this.step3}
                        >Dalje</Button>
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}

export default NewSP2;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/NewSP2.js